/**
 * @license @tabler/icons-react v3.10.0 - MIT
 *
 * This source code is licensed under the MIT license.
 * See the LICENSE file in the root directory of this source tree.
 */

import createReactComponent from '../createReactComponent.mjs';

var IconRewindBackward15 = createReactComponent("outline", "rewind-backward-15", "IconRewindBackward15", [["path", { "d": "M8 20h2a1 1 0 0 0 1 -1v-1a1 1 0 0 0 -1 -1h-2v-3h3", "key": "svg-0" }], ["path", { "d": "M15 18a6 6 0 1 0 0 -12h-11", "key": "svg-1" }], ["path", { "d": "M5 14v6", "key": "svg-2" }], ["path", { "d": "M7 9l-3 -3l3 -3", "key": "svg-3" }]]);

export { IconRewindBackward15 as default };
//# sourceMappingURL=IconRewindBackward15.mjs.map
